import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';
@Component({
    selector: 'app-accept-hunt',
    templateUrl: './accept-hunt.component.html',
    styleUrls: ['./accept-hunt.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AcceptHuntComponent extends BaseInjectorService implements OnInit {
  modal: any;
  SiteDetailsForm = new FormGroup({});
  //fields: FormlyFieldConfig[];
  options: FormlyFormOptions = {};
  model = {}
  fields: FormlyFieldConfig[];
  form = new FormGroup({});
  teamType: any;
  message: any = "";
  constructor(private detectChanges: ChangeDetectorRef, private appService: AppService, private route: ActivatedRoute, public treasurehuntService: TreasurehuntService) {
    super()

  }

  ngOnInit() {

    this.fields = [
      {
        key: 'CO',
        type: 'input',
        className: 'treasure-hunt-custom-input-hunt-type',
        props: {
          appearance: 'outline',
          type: 'number',
          //label: 'Average Emission Factor of grid electricity (kgCO₂/MWh)',
          label: 'TREASURE_HUNT.AVG_EMISSION_GRID_ELECTICITY_KGCO2_MWH',
          required: true,
          change: (field: any, $event) => {
            this.getValue(field.form.controls.CO.value);
          },
        },
        validation: {
          messages: {
            required: 'Enter Average Emission Factor of grid electricity (kgCO₂/MWh) ',
            min: '',
            max: '',
            pattern: (error: any, field: FormlyFieldConfig) => `Please enter digit`,
          },
        },
      },
      {
        key: 'LMU',
        type: 'input',
        className: 'treasure-hunt-custom-input-hunt-type',
        props: {
          appearance: 'outline',
          type: 'number',
          //label: 'Average electricity cost (LMU/MWh)',
          label: 'TREASURE_HUNT.AVG_ELECTRICITY_COST_LMU-MWH',
          required: true,
          change: (field: any, $event) => {
            this.getValue(field.form.controls.LMU.value);
          },
        },
        validation: {
          messages: {
            required: 'Enter Average electricity cost (LMU/m³)',
            min: '',
            max: '',
            pattern: (error: any, field: FormlyFieldConfig) => `Please enter digit`,
          },
        },
      },
      {
        key: 'power_consumption',
        type: 'input',
        className: 'treasure-hunt-custom-input-hunt-type',
        props: {
          appearance: 'outline',
          type: 'tel',
          label: 'TREASURE_HUNT.TOTAL_ENERGY_CONSUMPTION_AT_SITE_MWH_YEAR',
          //label: 'Total electrical energy consumption at Site (MWh/year)',
          required: true,

          // keypress: (field, $event)=>{ 
          //       console.log("field=",JSON.stringify(field)+"event=",$event);
          //       this.getValue(field.form.controls.power_consumption.value);
          //   },
          keypress: (field, $event) => {
            var charCode = ($event.which) ? $event.which : $event.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
              return false;
            else
              //$event.target.value=$event.target.value.replace(/^\d+(\.\d{1,2})?$/,"");
              //$event.target.value=$event.target.value.toFixed(2);
              return true;
          },
          // pattern:/^[1-9][0-9]?/
          pattern: /^\d+(\.\d{1,2})?$/
        },
        validation: {
          messages: {
            required: 'Enter Total electrical energy consumption at Site (MWh/year) ',
            pattern: (error: any, field: FormlyFieldConfig) => `Please enter valid number`,
          },
        },
      }
    ];


  }
  ionViewDidEnter() {
    if (!this.teamType) {
      if (this.treasurehuntService.TreasureHuntinfo['currentSiteInfo']) {
        this.fields[0].formControl.setValue(this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_CO2);
        this.fields[1].formControl.setValue(this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_LMU);
      }
      this.fields[0].formControl.valueChanges
        .subscribe(res => {
          let coTenPercentage = (10 / 100) * this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_CO2;
          let coMinus = this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_CO2 - coTenPercentage;
          let CoMax = this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_CO2 + coTenPercentage;
          this.fields[0].props.min = Number(coMinus);
          this.fields[0].props.max = Number(CoMax);
          if (res > CoMax || res < coMinus) {
            let mesg = "Please enter the value  between " + coMinus + " and " + CoMax;
            this.fields[0].validation.messages.min = mesg;
            this.fields[0].validation.messages.max = mesg;
          }
          this.detectChanges.detectChanges();

        });
      this.fields[1].formControl.valueChanges
        .subscribe(res => {
          let coTenPercentage = (10 / 100) * this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_LMU;
          let coMinus = this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_LMU - coTenPercentage;
          let CoMax = parseInt(this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].avg_LMU) + coTenPercentage;
          this.fields[1].props.min = Number(coMinus);
          this.fields[1].props.max = Number(CoMax);
          if (res > CoMax || res < coMinus) {
            let mesg = "Please enter the value  between " + coMinus + " and " + CoMax;
            this.fields[1].validation.messages.min = mesg;
            this.fields[1].validation.messages.max = mesg;
          }
          this.detectChanges.detectChanges();

        });
      this.fields[2].formControl.valueChanges
        .subscribe(res => {
          if (res) {
            this.detectChanges.detectChanges();
          }
        });
    }
  }
  getValue(abc) {
  }

  dismiss() {
    this.modal.dismiss();
  }
  update() {
    this.updateSite();
  }
  async updateSite() {
    let obj = {
      treasure_hunt_id: this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].treasure_hunt_id,
      site: this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].site,
      site_name: this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].site_name, active: true, avg_CO2: Number(this.fields[0].formControl.value),
      accepted: true, no_of_attempts: this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].no_of_attempts, avg_LMU: Number(this.fields[1].formControl.value), total_energy_consumption: Number(this.fields[2].formControl.value),
      site_start_date: this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].site_start_date, docId: this.treasurehuntService.TreasureHuntinfo['currentSiteInfo'].id
    }

    await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant('APP_LOADING')));
    await this.lhFire.update(`treasure_hunt/${obj.treasure_hunt_id}/sites`, obj.site, obj);
    this.modal.dismiss(true);
    this.overlayService.presentToast(this.createToastOptions(this.translate.instant("Treasure Hunt Accepted")));
    this.lhStorage.set("treasureHunt", this.treasurehuntService.TreasureHuntinfo)
    this.router.navigate(['/dashboard']);
  }


}